module.exports = __webpack_public_path__ + "media/application/images/home/intro_images/feature_ice_mob-098220e948407c35331374678710ff3e.jpg";